import { render, staticRenderFns } from "./ModalPriceChange.vue?vue&type=template&id=35656af6&scoped=true"
import script from "./ModalPriceChange.vue?vue&type=script&lang=js"
export * from "./ModalPriceChange.vue?vue&type=script&lang=js"
import style0 from "./ModalPriceChange.vue?vue&type=style&index=0&id=35656af6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35656af6",
  null
  
)

export default component.exports